import { HTTPSTATUS } from '../../../enums/HTTPSTATUS.js';
import FORMPOST from '../../DOM/form/FORMPOST.js';
/** Represents a standardized response from API get() calls */
export default class PAYLOAD extends Map {
    status = HTTPSTATUS.OK; // HTTP Status Code
    log = new Array(); // Log messages
    message = ''; // Message from the server
    response = []; //{[key: string]: any};
    exception = new Array(); // Exception/Error
    constructor(obj = {}) {
        super();
    }
    /** Retrieves the Payload's HTTP Status Code */
    getStatus() {
        return this.status;
    }
    /** Retrieves the Payload Message that was generated on the server */
    getMessage() {
        return this.message;
    }
    /** Retrieves the Payload Exception that was generated on the server (if exists) */
    getException() {
        return this.exception;
    }
}
export { FORMPOST, HTTPSTATUS };
